export const LARGE_ORDER_BREAKPOINT = 3_000_000;
export const ONBOARDING_ORDER_MIN_MEMBERCOUNT = 5000;
export const MAX_SPONSORED_MESSAGE_CHAR_COUNT = 170;

export const MINIMUM_ORDER_EXCEPTION_USER_IDs = [1063307871, 1475063456];
export const PANEL_LINKS = {
  ONBOARDING_MOHTAVADARAN_LINK:
    "https://ble.ir/mohtavadaran/9260275544051136/1689661822487",
  TERMS:
    "https://bale.ai/terms/#advertisement?utm_source=tablighat&utm_medium=rules_button&utm_campaign=landing",
  SUPPORT_BOT: "https://ble.ir/supportbot",
  FAQ: "https://bale.ai/faq",
  WEB: "https://web.bale.ai",
};

// also change due strings
export const MAX_SPONSORED_MESSAGE_IMAGE_SIZE = 10 * 1024 * 1024;
export const MAX_DIALOG_MESSAGE_IMAGE_SIZE = 10 * 1024 * 1024;
export const MAX_AUTH_DUCUMENT_SIZE = 10 * 1024 * 1024;

// GeneralConfig
export const GeneralConfig = {
  GenderPrice: 30,
  InstantPrice: 30,
};
